import _ from 'lodash';
import template from './radniNalogWizardForm.html';

class RadniNalogWizardFormController {
    constructor($uibModal, DS, AppConfiguration, logger, $state) {
        this.step = 1;
        this.$uibModal = $uibModal;
        this.logger = logger;
        this.$state = $state;
        DS.findAll('ProtetskiRad').then(response => {
            this.protetski_rad = response;
        });
        this.datastore = () => {
            return DS;
        };
        this.fazeListView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'ListView');
        this.stavkeNalogaListView = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'ListView');
        this.fazeEditView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'EditView');
        this.stavkeCreateView = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'CreateView');
    }

    $onInit() {
        this.osnovniPodaciFields = this.fields[0];
        this.stavkeNalogaFields = this.fields[1];
        this.napomenaField = this.fields[2];
        this.model = angular.copy(this.item);
        this.model.stavke = [];
        this.model.faze = [];
        this.model.veze = [];
        this.pozicije = [];
        this.groupedStavke = [];
    }

    show(step) {
        this.step = step;
    }

    next() {
        if (this.step < 4) {
            this.step++;
        }
    }

    prev() {
        if (this.step > 1) {
            this.step--;
        }
    }

    cancel() {
        const previousWindowKeyDown = window.onkeydown;
        swal(
            {
                title: 'Prekid unosa novog radnog naloga',
                text: 'Želite odustati od unosa novog radnog naloga?',
                type: 'warning',
                showCancelButton: true,
                closeOnConfirme: true
            },
            () => {
                window.onkeydown = previousWindowKeyDown;
                this.$state.go('dashboard');
            }
        );
    }

    resolveNazivProtetskogRada(stavka) {
        const item = _.find(this.protetski_rad, { id: stavka.protetski_rad });
        if (_.isUndefined(item)) {
            return '';
        }
        return item.naziv;
    }

    pozicijaClicked(pozicija) {
        if (_.isObject(pozicija) && !pozicija.veza) {
            this.insertStavkuNaloga(pozicija).then(() => {
                this.pozicije.push(Object.assign({}, pozicija, { selected: true }));
            });
        } else {
            // ako je veza već odbrana makni je iz liste,
            // ako nije stavie je u listu odabranih veza
            const veza = _.find(this.model.veze, item => {
                return item.pozicija === pozicija.broj;
            });

            if (veza) {
                this.pozicije = _.filter(this.pozicije, item => {
                    return item.broj !== veza.pozicija;
                });
                this.removeVezuNaloga(veza);
            } else {
                this.pozicije.push(Object.assign({}, pozicija, { selected: !pozicija.selected }));
                this.insertVezuNaloga(pozicija);
            }
        }
    }

    insertVezuNaloga(pozicija) {
        this.model.veze.push({ pozicija: pozicija.broj });
    }

    insertStavkuNaloga(pozicija) {
        const model = {};

        if (_.isObject(pozicija)) {
            model.pozicija = pozicija.broj;
        }

        const modal = this.$uibModal.open({
            component: 'stavkaNalogaForm',
            size: 'lg-extra',
            // windowClass: 'modal-lg-extra',
            resolve: {
                item: function() {
                    return model;
                }
            }
        });

        return modal.result.then(model => {
            this.model.stavke.push(model);
            this.groupStavke();
        });
    }

    copyStavke(from, to) {
        // debugger;
        if (from && from.selected && from.broj !== to.broj && !to.veza && !from.veza) {
            // debugger;
            let stavke = _.filter(this.model.stavke, { pozicija: from.broj });
            let clones = _.cloneDeep(stavke);
            _.forEach(clones, clone => {
                // debugger;
                clone.pozicija = to.broj;
                this.model.stavke.push(clone);
                this.pozicije.push(Object.assign({}, to, { selected: true }));
            });

            this.groupStavke();
        }
    }

    groupStavke() {
        // grupiraj stavke naloga po protetskom radu
        // {
        //     "protetski_rad": 21,
        //     "pozicije": [
        //            12,
        //            22,
        //            18
        //     ],
        //     cjenik: 1
        // },
        const DS = this.datastore();
        const StavkaNaloga = DS.definitions['StavkaNaloga'].createInstance();
        this.groupedStavke = StavkaNaloga.group(this.model.stavke);
    }

    insertFazu() {
        const DS = this.datastore();
        const model = {
            radni_nalog: this.item.id
        };
        const view = this.fazeEditView;
        const modal = this.$uibModal.open({
            component: 'modalForm',
            size: 'lg',
            resolve: {
                item: function() {
                    return model;
                },
                view: function() {
                    return view;
                },
                formClass: function() {
                    return 'standard';
                }
            }
        });

        modal.result.then(model => {
            this.model.faze.push(model);
        });
    }

    deleteFazu(item) {
        this.model.faze = this.model.faze.filter(f => f !== item);
    }

    submit(item) {
        this.form.$setSubmitted(true);
        if (this.form.$invalid) {
            return;
        }
        this.onSubmit({ item: item });
    }

    removeStavkuNaloga(item) {
        _.remove(this.model.stavke, stavka => {
            return stavka.protetski_rad === item.protetski_rad && stavka.cjenik === item.cjenik;
        });

        item.pozicije.forEach(pozicija => {
            const poz = _.findIndex(this.pozicije, i => {
                return i.broj === pozicija;
            });

            if (poz !== -1) {
                this.pozicije.splice(poz, 1);
            }
        });
        this.groupStavke();
    }

    removeVezuNaloga(item) {
        _.remove(this.model.veze, veza => {
            return veza.pozicija === item.pozicija;
        });
    }
}

RadniNalogWizardFormController.$inject = ['$uibModal', 'DS', 'AppConfiguration', 'logger', '$state'];

const RadniNalogWizardFormComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: RadniNalogWizardFormController,
    controllerAs: 'vm',
    bindings: {
        fields: '<',
        item: '<',
        onSubmit: '&'
    }
};

export { RadniNalogWizardFormComponent };
export { RadniNalogWizardFormController };



// WEBPACK FOOTER //
// ./app/components/radniNalog/radniNalogWizardForm.component.js